import { render, staticRenderFns } from "./SaveConfirmation.vue?vue&type=template&id=7fedf4ca&"
import script from "./SaveConfirmation.vue?vue&type=script&lang=js&"
export * from "./SaveConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports